$(document).ready(function() {
  var theEMAIL = $(".blueLink").text();
  $("#RecoverEmail").val(theEMAIL);

  $(".ex").click(function() {
    $(".popOverlay").hide();
  });

  $("#CityFilterInput").chained("#ProvFilterInput"); 
  var integrationURL = "https://www.uconnectsecure.co.za";

  function dynamicPullCart(customer) {
    $(".cartCredInfoPull").each(function() {
      var element = $(this);
      var url = integrationURL + "/getCreditLimit/" + customer;
      $.get(url, function(data) {
        var data = data;
        if (customer == "WEBSITE") {
          var creditLimVar = 0;
          var creditDebtVar = 0;
        } else {
          var creditLimVar = data.creditLimit[0].AMTCRLIMT;
          var creditDebtVar = data.creditLimit[0].AMTBALDUET;
        }
        var creditSum = creditLimVar - creditDebtVar;
        element.find('#cartCreditInfo').text("R " + creditSum);
      });
    });
  }
  // must push through as a quoted string	
  dynamicPullCart('WEBSITE');
  

  var myurl = '/collections/';
  var currenturl = window.location;
  if(myurl == currenturl) {
    window.location.href = '/pages/all-products'
  } 

  $(".site-nav--has-dropdown").mouseover(function(){
    $(".site-nav__dropdown").stop().animate({height:150},200);
  });
  $(".site-nav__dropdown").mouseleave(function(){
    $(".site-nav__dropdown").stop().animate({height:0},200);
  }); 
  $(".main-content").mouseover(function(){
    $(".site-nav__dropdown").stop().animate({height:0},200);
  }); 

  $("#myAccTextBtn").mouseover(function(){
    $(".accDropdown").stop().animate({height:220},200);
  });

  $(".accDropdown").mouseleave(function(){
    $(".accDropdown").stop().animate({height:0},200);
  }); 

  $(".main-content").mouseenter(function(){
    $(".accDropdown").stop().animate({height:0},200);
  }); 

  function isEmpty( el ){
    return !$.trim(el.html())
  }  

  var auto_inc_id = 1; //initialise value of auto incremented id to 0
  var sliderNumber;
  $('ul.slides li').each(function(){ //loop through each list element of ul
    sliderNumber = $(this).find("#autoInc").text();//increment auto_inc_id by one
    $(this).attr("id","textSwap" + sliderNumber); //attach to current li an id attribute that has auto_inc_id as its value
    auto_inc_id++; //increment auto_inc_id by one -> old code
  });

  if ($(".section-header--title").text() == "Company Overview") {
    $(".pullSectNav a:nth-of-type(1)").css("color","#000");
  }  
  if ($(".section-header--title").text() == "BBBEEE Status") {
    $(".pullSectNav a:nth-of-type(2)").css("color","#000");
  }
  if ($(".section-header--title").text() == "Careers") {
    $(".pullSectNav a:nth-of-type(3)").css("color","#000");
  }
  if($(".section-header--title:contains('Careers / ')").length) {
    $(".pullSectNav a:nth-of-type(3)").css("color","#000");
  }
  if ($(".section-header--title").text() == "Franchise") {
    $(".pullSectNav a:nth-of-type(4)").css("color","#000");
  }
  if ($(".section-header--title").text() == "Distributors") {
    $(".pullSectNav a:nth-of-type(5)").css("color","#000");
  }
  if ($(".section-header--title").text() == "Suppliers") {
    $(".pullSectNav a:nth-of-type(6)").css("color","#000");
  }
  if ($(".section-header--title").text() == "Contact Us") {
    $(".pullSectNav a:nth-of-type(1)").css("color","#000");
  }
  if ($(".section-header--title").text() == "Training") {
    $(".pullSectNav a:nth-of-type(2)").css("color","#000");
  }
  if ($(".section-header--title").text() == "E-Learning") {
    $(".pullSectNav a:nth-of-type(2)").css("color","#000");
  }
  if($(".section-header--title:contains('E-Learning / ')").length) {
    $(".pullSectNav a:nth-of-type(2)").css("color","#000");
  }
  if ($(".section-header--title").text() == "Solutions") {
    $(".pullSectNav a:nth-of-type(3)").css("color","#000");
  }
  if($(".section-header--title:contains('Solutions / ')").length) {
    $(".pullSectNav a:nth-of-type(4)").css("color","#000");
  }
  if ($(".section-header--title").text() == "Account Info") {
    $(".pullSectNav a:nth-of-type(1)").css("color","#000");
  }
  if ($(".section-header--title").text() == "Credit Info") {
    $(".pullSectNav a:nth-of-type(2)").css("color","#000");
  }
  if ($(".section-header--title").text() == "Orders") {
    $(".pullSectNav a:nth-of-type(3)").css("color","#000");
  }
  if ($(".section-header--title").text() == "My Addresses") {
    $(".pullSectNav a:nth-of-type(4)").css("color","#000");
  }
  if ($(".section-header--title").text() == "Newsletter") {
    $(".pullSectNav a:nth-of-type(5)").css("color","#000");
  }
  if ($(".section-header--title").text() == "Privacy Policy") {
    $(".pullSectNav a:nth-of-type(1)").css("color","#000");
  } 
  if ($(".section-header--title").text() == "Terms & Conditions") {
    $(".pullSectNav a:nth-of-type(2)").css("color","#000");
  } 
  if ($(".section-header--title").text() == "Site Map") {
    $(".pullSectNav a:nth-of-type(3)").css("color","#000");
  } 
  if ($(".section-header--title").text() == "Main Catalogue & Pricelist") {
    $(".pullSectNav a:nth-of-type(1)").css("color","#000");
  } 
  if ($(".section-header--title").text() == "Short Form Catalogues") {
    $(".pullSectNav a:nth-of-type(2)").css("color","#000");
  }
  if ($(".section-header--title").text() == "Specials Page") {
    $(".pullSectNav a:nth-of-type(3)").css("color","#000");
  }
  if ($(".section-header--title").text() == "Certificates") {
    $(".pullSectNav a:nth-of-type(4)").css("color","#000");
  }
  if ($(".section-header--title").text() == "Credit Application") {
    $(".pullSectNav a:nth-of-type(5)").css("color","#000");
  }
  if ($(".section-header--title").text() == "Technical Specifications") {
    $(".pullSectNav a:nth-of-type(6)").css("color","#000");
  }
  if ($(".section-header--title").text() == "Latest News") {
    $(".pullSectNav a:nth-of-type(1)").css("color","#000");
  }
  if($(".section-header--title:contains('Latest News / ')").length) {
    $(".pullSectNav a:nth-of-type(1)").css("color","#000");
  }
  if ($(".section-header--title").text() == "Events") {
    $(".pullSectNav a:nth-of-type(2)").css("color","#000");
  }

  $(window).bind("pageshow", function() {
    $(".header-bar__search-input").val('');
    $(".header-bar__search-input").css('width','65%');
    $(".header-bar__search-input").css('margin-right','20px');
  });

  $('.header-bar__search-input').bind('focus',function() {
    $(".header-bar__search-input").css('width','100%');
    $(".header-bar__search-input").css('margin-right','55px');
    if (this.value!='') {
      this.value='';
    }           
  }); 

  $('.header-bar__search-input').bind('blur',function() {
    $(".header-bar__search-input").css('width','65%');
    $(".header-bar__search-input").css('margin-right','20px');
  });   

  $('#topSearchSec').bind('focus',function() {
    if (this.value!='') {
      this.value='';
    }           
  });   

  function formatMoney(number, places, symbol, thousand, decimal) {
    places = !isNaN(places = Math.abs(places)) ? places : 2;
    symbol = symbol !== undefined ? symbol : "R ";
    thousand = thousand || " ";
    decimal = decimal || ".";
    var   negative = number < 0 ? "-" : "",
        i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;
    return symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
  }; 

  function halfMoney(number, places) {
    places = !isNaN(places = Math.abs(places)) ? places : 2;
    var   negative = number < 0 ? "-" : "",
        i = parseFloat(number = Math.abs(+number || 0).toFixed(places), 10) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;
    return negative + (j ? i.substr(0, j) : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1") + (places ? Math.abs(number - i).toFixed(places).slice(4) : "");
  };

  function removeA(arr) {
    var what, a = arguments, L = a.length, ax;
    while (L > 1 && arr.length) {
      what = a[--L];
      while ((ax= arr.indexOf(what)) !== -1) {
        arr.splice(ax, 1);
      }
    }
    return arr;
  }

  $(".switchBusiness").click(function() {  
    $(".prodCertHolder").fadeOut(200);    
    setTimeout(function(){
      $(".busCertHolder").fadeIn(200);
    }, 500);
  });

  $(".switchProduct").click(function() {  
    $(".busCertHolder").fadeOut(200);  
    setTimeout(function(){  
      $(".prodCertHolder").fadeIn(200);
    }, 500);
  });

  $(".switchACDCDist").click(function() {  
    $("#rhomdist").fadeOut(200);  
    setTimeout(function(){  
      $("#acdcdist").fadeIn(200);
    }, 500);
  });

  $(".switchDistrib").click(function() {  
    $("#acdcdist").fadeOut(200);    
    setTimeout(function(){
      $("#rhomdist").fadeIn(200);
    }, 500);
  }); 

  // Clear cart when adding new booking
  $('#logout-btn').on('click', function(e){
    e.preventDefault();
    setTimeout(function() {
      window.location = "/cart/clear/";
    }, 100);
    setTimeout(function() {
      window.location = "/account/logout/";
    }, 150);
  }); 

  if ($('.form-successOne').is(":visible")) {
    $('.form-successTwo').hide();
  } else if ($('.form-successTwo').is(":visible")) {
    $('.form-successOne').hide();
  }

  $(".mobile-nav-trigger").click(function(){
    if  ($(".mobile-nav").is(":visible")){
      $(".mobile-nav").hide();
      $(".main-content").css("margin-top","0px")
    }else {
      $(".mobile-nav").show();
      $(".main-content").css("margin-top","0px")
    }
  }); 

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length,c.length);
      }
    }
    return "";
  }

  function checkCookie() {
    var numFav = getCookie("noOfFavs");
    if(numFav.length == 0) {
      $('.theActualNo').text('0');
    } else {
      $('.theActualNo').text(numFav);
    }
  }  
  checkCookie();

  function favGetCookie() {
    var key,val,res;
    //get all cookie
    var oldCookie = document.cookie.split(';');
    for (var i = 0; i < oldCookie.length; i++) {
      key = oldCookie[i].substr(0,oldCookie[i].indexOf("="));
      val = oldCookie[i].substr(oldCookie[i].indexOf("=")+1);
      key = key.replace(/^\s+|\s+$/g,"");
      //find "user_cookie"
      if(key == "favItems") {
        res = val;
      }
    }
    
    if (res == undefined) {
      return null;
    } else {
      res = JSON.parse(res);
      return res.user;
    }
  }

  var NOtemp = favGetCookie();
  if (NOtemp === null) {
    $('.theActualNo').text(0);
  } else {
    $('.theActualNo').text(NOtemp.length);
  }

  //ALL OF THIS IS TEMP AND NEEDS TO BE REOMVED ONCE THE FILTER GOES LIVE  
  var theactNoVal = parseFloat($('.theActualNo').text());
  if(theactNoVal >= 1) {
    $('.nofavitems').hide();
  } else {
    $('.nofavitems').show();
  }
  /*
  if ($(".customerACC").text() == "ACE034") {
    
    $(".advSearchOp").show();
    $("#searchTerms").show();
    $("#braProdTab").show();
    $(".catProdTab").show();
    $(".searchBy").show();
    $(".catProdTabTitle").show();
    $("#PlusBox").show();
    $(".searchTerms").show();
    $(".pricing").show(); 
    $("#catScript").show();
    $(".openerType").show();
    $(".catProdTabHold").show();
    $(".typeDiv").show();
    $(".openerCheck").show();
    $(".skuCheck").show();
    $(".typeTitle").show();
    $(".AdvUpdFilter").show();
    $(".searchBy").show();
    $(".defaultFilter").show();
    $(".reloadFilter").show();
    $("#sortByContainer").show();
    $("#filterBox").show();
    
  }
  */
  $('#inputCompOne').focus(function(){
    $(this).removeAttr('text');
  });
  
});